import { useRoleContext } from "./useRoleContext";
import { useSwrFetch } from "./useSwrFetch";

export function useCarrierLanePreferences() {
  const { role } = useRoleContext();

  const url = role?.id ? `/carriers/${role.id}/lanes/preferences` : null;

  const { data, loading, error, refetch } = useSwrFetch<CarrierLanePreferences>(
    {
      url,
      errorMessage: "Failed to fetch carrier lane preferences",
      errorMessageKey: "message",
    },
  );

  return {
    preferences: data ?? null,
    loading,
    error,
    refetch,
  };
}
